export const ACTIONS = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
};

export const showNotification = payload => ({
  type: ACTIONS.SHOW_NOTIFICATION,
  payload,
});

export const hideNotification = () => ({
  type: ACTIONS.HIDE_NOTIFICATION,
  payload: {},
});
